// ##############################
// // // ExtendedForms view styles
// #############################

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx'
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx'

const extendedFormsStyle = {
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  label: {
    cursor: 'pointer',
    paddingLeft: '0',
    color: 'rgba(0, 0, 0, 0.76)',
    fontSize: '14px',
    lineHeight: '1.428571429',
    fontWeight: '400',
    display: 'inline-flex',
    marginLeft: '15px'
  },
  mrAuto: {
    marginRight: 'auto'
  },
  mlAuto: {
    marginLeft: 'auto'
  },
  conditionRoot: {
    marginTop: '2px',
    padding: '5px'
    // border: '1px solid black'
  },
  // this is for userSettings compoent

  settingGroupTitle: {
    margin: '3px 5px',
    fontWeight: 'bold'
  },
  // for the paper
  settingGroup: {
    padding: '5px',
    margin: '5px 0px'
  },
  textField: {
    marginLeft: '20px',
    marginRight: '20px',
    width: 200
  }
}

export default extendedFormsStyle
